"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doStuff2 = exports.doStuff = exports.test1 = exports.ExampleRpcController = void 0;
var BaseRpcTypes_1 = require("./BaseRpcTypes");
var ExampleRpcController = /** @class */ (function () {
    function ExampleRpcController() {
        var _this = this;
        this.inc = function (request) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, (0, BaseRpcTypes_1.Success)({ res1: request.arg1 + 1 })];
        }); }); };
        this.dec = function (request) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, (0, BaseRpcTypes_1.Success)({ res2: request.arg2.substr(1) })];
        }); }); };
    }
    return ExampleRpcController;
}());
exports.ExampleRpcController = ExampleRpcController;
function sampleClient(arg) {
    switch (arg.controller) {
        case 'Example': {
            switch (arg.method) {
                case 'inc':
                    arg.cb({ status: 'success', result: { res1: arg.request.arg1 + 1 } });
                    break;
                case 'dec':
                    arg.cb({ status: 'success', result: { res2: arg.request.arg2.toLowerCase() } });
            }
            break;
        }
        case 'HostProfile':
            console.log(arg);
    }
}
function test1() {
    sampleClient({
        controller: 'Example',
        method: 'inc',
        request: { arg1: 1 },
        cb: function (resp) {
            if (resp.status === 'success') {
                console.log(resp.result.res1);
            }
        },
    });
    sampleClient({
        controller: 'Example',
        method: 'dec',
        request: { arg2: 'asdas' },
        cb: function (resp) {
            if (resp.status === 'success') {
                console.log(resp.result.res2.toUpperCase());
            }
        },
    });
}
exports.test1 = test1;
function doStuff(o) {
    var a = new ExampleRpcController();
    switch (o.controller) {
        case 'Example':
            break;
        case 'HostProfile':
            switch (o.method) {
                case 'read':
                    console.log(o.request.limit, a);
                    break;
                case 'create':
                    console.log(o.request.entity.facebook);
                    break;
                case 'customMethod':
                    console.log(o.request);
            }
            break;
        case 'Trip':
            switch (o.method) {
                case 'read':
                    console.log(o.request.filters);
                    break;
                case 'create':
                    console.log(o.request.entity.currentVersion);
            }
            console.log(o.method);
    }
}
exports.doStuff = doStuff;
function doStuff2(o) {
    switch (o.controller) {
        case 'HostProfile':
            switch (o.method) {
                case 'read':
                    console.log(o.response.status === 'success' ? o.response.result.entities[0].facebook : undefined);
                    break;
                case 'create':
                    console.log(o.response.status === 'success' ? o.response.result.entityId : null);
                    break;
                case 'customMethod':
                    console.log(o.response);
            }
            break;
        case 'Trip':
            switch (o.method) {
                case 'read':
                    console.log(o.response.status === 'success' ? o.response.result.entities[0].currentVersion : undefined);
                    break;
                case 'update':
                    console.log(o.response.status === 'success' ? o.response.result.entityId : null);
            }
            console.log(o.method);
    }
}
exports.doStuff2 = doStuff2;
//# sourceMappingURL=Rpc.js.map